export const CategoryConfig = {
  "Junior Handling (Conformation)": {
    header: (event, attendees) => (
      <>
        <h5>{event.event_category} | {event.event_number} | {event.formatted_start_date} to {event.formatted_end_date}</h5>
      </>
    ),

  },

  "Junior Handling (Obedience)": {
    header: (event, attendees) => (
      <>
        <h5>{event.event_category} | {event.event_number} | {event.formatted_start_date} to {event.formatted_end_date}</h5>
        
      </>
    ),

  },

  "Chase Ability Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.event_category} | {event.event_number} | {event.formatted_start_date} to {event.formatted_end_date}</h5>
        <p> Judge: {attendees[0]?.judge}</p>
      </>
    ),

  },

  "Draft Dog Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.event_category} | {event.event_number} | {event.formatted_start_date} to {event.formatted_end_date}</h5>
        <p> Judge A: {attendees[0]?.judge_A} &nbsp; Judge B: {attendees[0]?.judge_B} &nbsp; Judge C: {attendees[0]?.judge_C}</p>
      </>
    ),

  },

  "Earthdog Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.event_category} | {event.event_number} | {event.formatted_start_date} to {event.formatted_end_date}</h5>
        <p> Judge A: {attendees[0]?.judge_A} &nbsp; Judge B: {attendees[0]?.judge_B} &nbsp; Judge C: {attendees[0]?.judge_C}</p>
      </>
    ),
  },

  "Herding Trials": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date} {event.venue_city ? `, ${event.venue_city}` : ''}, {event.province}</h5>
        <p>{event.event_type} | {event.event_number} | {attendees[0]?.division} | {attendees[0]?.level} | Judge: {attendees[0]?.judge}</p>
      </>
    ),
  },

  "Lure Coursing Field Trials": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date} {event.venue_city ? `, ${event.venue_city}` : ''}, {event.province}</h5>
        <p>{event.event_type} {event.event_number} | Judge A: {attendees[0]?.judge_A} | Judge B: {attendees[0]?.judge_B} | Judge C: {attendees[0]?.judge_C}</p>
      </>
    ),
  },

  "Pointing Field Dog Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date} {event.venue_city ? `, ${event.venue_city}` : ''}, {event.province}</h5>
        <p>{event.event_type} {event.event_number} | Judge: {attendees[0]?.judge}</p>
      </>
    ),
  },

  "Pointing Water Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.formatted_start_date} to {event.formatted_end_date} {event.venue_city ? `, ${event.venue_city}` : ''}, {event.province}</h5>
        <p>{event.event_type} {event.event_number} | Judge: {attendees[0]?.judge}</p>
      </>
    ),
  },

  "Retriever Field Trials": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} | {event.event_number} {event.formatted_start_date} to {event.formatted_end_date} {event.venue_city ? `, ${event.venue_city}` : ''}, {event.province}</h5>
        <p>{event.event_type} {event.event_number} | Judge A: {attendees[0]?.judge_A} | Judge B: {attendees[0]?.judge_B}</p>
      </>
    ),
  },
  "Retriever Hunt Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} {event.formatted_start_date} to {event.formatted_end_date} {event.venue_city ? `, ${event.venue_city}` : ''}, {event.province}</h5>
        <p>{event.event_type} {event.event_number} | Judge A: {attendees[0]?.judge_A} | Judge B: {attendees[0]?.judge_B}</p>
      </>
    ),
  },

  "Working Certificate Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} {event.formatted_start_date} to {event.formatted_end_date} {event.venue_city ? `, ${event.venue_city}` : ''}, {event.province}</h5>
        <p>{event.event_type} {event.event_number} | Judge A: {attendees[0]?.judge_A} | Judge B: {attendees[0]?.judge_B}</p>
      </>
    ),
  },

  "Scent Detection": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} {event.formatted_start_date} to {event.formatted_end_date} {event.venue_city ? `, ${event.venue_city}` : ''}, {event.province}</h5>
        <p>{event.event_type} {event.event_number} | {attendees[0]?.division} | {attendees[0]?.level} | Judge: {attendees[0]?.judge}</p>
      </>
    ),
  },

  "Spaniel Field Trials": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} {event.event_number} {event.formatted_start_date} to {event.formatted_end_date} {event.venue_city ? `, ${event.venue_city}` : ''}, {event.province}</h5>
        <p>{event.event_type} {event.event_number} | Judge A: {attendees[0]?.judge_A} | Judge B: {attendees[0]?.judge_B}</p>
      </>
    ),
  },

  "Spaniel Hunt Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} {event.formatted_start_date} to {event.formatted_end_date} {event.venue_city ? `, ${event.venue_city}` : ''}, {event.province}</h5>
        <p>{event.event_type} {event.event_number}  | Judge A: {attendees[0]?.judge_A} | Judge B: {attendees[0]?.judge_B}</p>
      </>
    ),
  },

  "Sprinter": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} {event.formatted_start_date} to {event.formatted_end_date} {event.venue_city ? `, ${event.venue_city}` : ''}, {event.province}</h5>
        <p>{event.event_type} {event.event_number}  | {attendees[0]?.division} | {attendees[0]?.level}</p>
      </>
    ),
  },

  "Tracking Tests": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} {event.formatted_start_date} to {event.formatted_end_date} {event.venue_city ? `, ${event.venue_city}` : ''}, {event.province}</h5>
        <p>{event.event_type} {event.event_number} | Judge: {attendees[0]?.judge}</p>
      </>
    ),
  },

  "Canine Good Neighbour": {
    header: (event, attendees) => (
      <>
        <h5>{event.club} {event.formatted_start_date} to {event.formatted_end_date} {event.venue_city ? `, ${event.venue_city}` : ''}, {event.province}</h5>
        <p>{event.event_type} {event.event_number}  | Judge: {attendees[0]?.judge}</p>
      </>
    ),
  },

};
